import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GalleryFilter } from '../cbj-gallery.models';
import { MenuItem } from '../../menu';
export class CbjFilterGalleryComponent implements OnInit {
/**
 * The galleries height
 * 
 */
height: string;
/**
 * The galleries width
 * 
 */
width: string;
/**
 * The columns width in pixels
 * 
 */
colWidth: number;
/**
 * The width of the space between cols
 * 
 */
gutterWidth: number;
/**
 * An array of classes to add to the img tags
 * 
 */
classes: string[] = [];
/**
 * The url to get image links from. It must return a response containing an array of image links for the key data
 * 
 */
url: string;
/**
 * Params to be sent to the image endpoint.
 * 
 */
params: any;
/**
 * 
 * 
 * $type {string} paramKeys
 */
paramKey: string;
/**
 * The filters for the gallery
 * 
 */
filters: GalleryFilter[];
/**
 * The title for the menu. If a string is passed, it will
 * be used as the title of the menu and the menu items will
 * be checkboxes for each filter. If false is passed, the
 * menu items will be buttons and the title will be the active filters title
 * 
 */
fTitle: string | boolean;
/**
 * An array of image links to pass to the gallery component
 * 
 */
images: string[];
/**
 * The menu items
 * 
 */
menuItems: MenuItem[] = [];
/**
 * @param {?} http
 */
constructor(private http: HttpClient) {}
/**
 * @return {?}
 */
ngOnInit() {
    this.getSetImages();
    this.makeMenu();
  }
/**
 * @return {?}
 */
private getSetImages() {
    this.http.get(this.url, {params: this.params})
      .subscribe((resp: any) => {
        this.images = resp.images;
      });
  }
/**
 * @return {?}
 */
private makeMenu() {
    let /** @type {?} */ i = 0;
    this.params[this.paramKey] = [];
    for (const /** @type {?} */ filter of this.filters) {
      this.menuItems.push({
        id: i,
        title: filter.name.charAt(0).toUpperCase() + filter.name.slice(1),
        active: true,
        value: filter.value,
        click: this.fTitle ? this.checkClick : this.btnClick
      });
      this.params[this.paramKey].push(filter.value);
      i++;
    }
    this.params[this.paramKey] = JSON.stringify(this.params[this.paramKey]);
  }
private checkClick = (item) => {
    let /** @type {?} */ p = JSON.parse(this.params[this.paramKey]);
    if (item.active) {
      p = p.filter(param => param !== item.value);
      p.push(item.value);
      this.params[this.paramKey] = JSON.stringify(p);
    }else {
      this.params[this.paramKey] = JSON.stringify(p.filter(param => param !== item.value));
    }
    this.getSetImages();
  }
private btnClick = (item) => {
    if (!item.active) {
      this.params = item.value;
    }
    this.getSetImages();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-filter-gallery',
  template: `
    <div class="container-fluid" [style.height]="height" [style.width]="width">
        <div class="row">
            <cbj-menu [options]="{arrow: true, checkBox: fTitle, title: fTitle}"
                      [items]="menuItems">
            </cbj-menu>
        </div>
        <cbj-gallery height="100%"
                     width="auto"
                     [images]="images"
                     [classes]="classes"
                     [colWidth]="colWidth"
                     [gutterWidth]="gutterWidth">
        </cbj-gallery>
    </div>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'height': [{ type: Input, args: ['height', ] },],
'width': [{ type: Input, args: ['width', ] },],
'colWidth': [{ type: Input, args: ['colWidth', ] },],
'gutterWidth': [{ type: Input, args: ['gutterWidth', ] },],
'classes': [{ type: Input, args: ['classes', ] },],
'url': [{ type: Input, args: ['url', ] },],
'params': [{ type: Input, args: ['params', ] },],
'paramKey': [{ type: Input, args: ['paramKey', ] },],
'filters': [{ type: Input, args: ['filters', ] },],
'fTitle': [{ type: Input, args: ['fTitle', ] },],
};
}

function CbjFilterGalleryComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjFilterGalleryComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjFilterGalleryComponent.ctorParameters;
/** @type {?} */
CbjFilterGalleryComponent.propDecorators;
/**
 * The galleries height
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.height;
/**
 * The galleries width
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.width;
/**
 * The columns width in pixels
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.colWidth;
/**
 * The width of the space between cols
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.gutterWidth;
/**
 * An array of classes to add to the img tags
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.classes;
/**
 * The url to get image links from. It must return a response containing an array of image links for the key data
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.url;
/**
 * Params to be sent to the image endpoint.
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.params;
/**
 * 
 * 
 * $type {string} paramKeys
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.paramKey;
/**
 * The filters for the gallery
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.filters;
/**
 * The title for the menu. If a string is passed, it will
 * be used as the title of the menu and the menu items will
 * be checkboxes for each filter. If false is passed, the
 * menu items will be buttons and the title will be the active filters title
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.fTitle;
/**
 * An array of image links to pass to the gallery component
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.images;
/**
 * The menu items
 * 
 * @type {?}
 */
CbjFilterGalleryComponent.prototype.menuItems;
/** @type {?} */
CbjFilterGalleryComponent.prototype.checkClick;
/** @type {?} */
CbjFilterGalleryComponent.prototype.btnClick;
/** @type {?} */
CbjFilterGalleryComponent.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
